import { render, staticRenderFns } from "./modalCadastroProduto.vue?vue&type=template&id=a6655774"
import script from "./modalCadastroProduto.vue?vue&type=script&lang=js"
export * from "./modalCadastroProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports